export default __webpack_public_path__ + "static/media/welcome-back.d671e76e.png";